/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {JsonLdCollection} from '@/store/types';
import {DlcInterface, SpeciesInterface} from '@/store/modules/game/types';

/**
 * Species loader mixin.
 * Ensures that the species data is loaded into components at created.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component
export default class GameData extends Vue {
    @Action('setLocked', {namespace: 'gameModule'})
    public setLocked!: (locked: boolean) => void;

    @Getter('locked', {namespace: 'gameModule'})
    public locked!: boolean;

    @Action('getSpecies', {namespace: 'gameModule'})
    public getSpecies!: () => Promise<JsonLdCollection<SpeciesInterface>>;

    @Action('getDlc', {namespace: 'gameModule'})
    public getDlc!: () => Promise<JsonLdCollection<DlcInterface>>;

    @Action('getFavourites', {namespace: 'gameModule'})
    public getFavourites!: () => Promise<JsonLdCollection<any>>;

    public includeFavourites: boolean = true;

    /**
     * Created lifecycle event.
     * @return {Promise<void>}
     */
    public async created(): Promise<void> {
        const promises: Promise<any>[] = [
            this.getSpecies(),
            this.getDlc(),
        ];

        if (this.includeFavourites) {
            promises.push(this.getFavourites());
        }

        await Promise.all(promises);

        this.setLocked(false);
    }
}

